import React, { useEffect } from 'react'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

import { SidebarConfigProps } from '@/reducers/sidebar.slice'
import { User } from '@/reducers/auth/userReducer'
import { Rail } from './rail'
import { Expanded } from './expanded'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'

interface SidebarProps {
  device: string
  dropdownOptions: Array<{ icon: IconProp; onClick: () => void; text: string }>
  categories?: Record<string, SidebarConfigProps> | null
  user?: User | null
}

export const Sidebar = ({
  device,
  dropdownOptions,
  categories,
  user,
}: SidebarProps) => {
  const [isOpen, setIsOpen] = React.useState(true)
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  const isTablet = useIsDeviceWidth(DeviceWidth.tablet)
  const [selectedCategory, setSelectedCategory] = React.useState<string | null>(
    null
  )
  const isSmallDevice = isMobile || isTablet
  // Collapse automatically on small devices
  useEffect(() => {
    if (isSmallDevice) {
      setIsOpen(false)
    }
  }, [isSmallDevice])

  if (isOpen) {
    return (
      <Expanded
        device={device}
        footerOptions={dropdownOptions}
        categories={categories}
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
        user={user}
        selectedCategory={selectedCategory}
      />
    )
  }

  return (
    <Rail
      device={device}
      dropdownOptions={dropdownOptions}
      categories={categories}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(true)}
      onCategoryClick={(key) => {
        setSelectedCategory(key)
        setIsOpen(true)
      }}
    />
  )
}
